/* Rivox motion system — auto-tags key elements in rvx-* sections for
   scroll-reveal with sibling stagger. Safe by default: without JS the
   hidden state never applies (gated on html.rvx-motion). */
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (!("IntersectionObserver" in window)) return;

  var SELECTORS = [
    /* __headline and __eyebrow removed 07/2026: when the observer failed to
       fire, section headings (e.g. "HOW IT WORKS.") stayed invisible and
       read as giant whitespace. Headings must never depend on JS to show. */
    '.rvx-pp3__card',
    '.rvx-pp4__tile',
    '.rvx-pair__media',
    '.rvx-pair__content',
  ];

  function init() {
    var els = document.querySelectorAll(SELECTORS.join(","));
    if (!els.length) return;
    document.documentElement.classList.add("rvx-motion");

    /* stagger siblings that share a parent */
    var groups = new Map();
    els.forEach(function (el) {
      el.setAttribute("data-rvx-reveal", "");
      var parent = el.parentElement;
      var idx = groups.get(parent) || 0;
      el.style.setProperty("--rvx-d", Math.min(idx * 90, 450) + "ms");
      groups.set(parent, idx + 1);
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("rvx-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach(function (el) {
      /* skip elements already in view at load (above the fold) */
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) {
        el.classList.add("rvx-in");
      } else {
        io.observe(el);
      }
    });

    /* Failsafe: if the observer never fires (editor iframes, odd scroll
       containers), force-reveal everything after 3s so no content can
       remain permanently invisible. */
    setTimeout(function () {
      document.querySelectorAll("[data-rvx-reveal]:not(.rvx-in)").forEach(function (el) {
        el.classList.add("rvx-in");
      });
    }, 3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ── Mobile UX patch (07/2026) ──────────────────────────────────
   1) Lazy-load below-the-fold autoplay videos: any <video data-rvx-src>
      only downloads once it approaches the viewport (fixes the homepage
      pulling every video at once on load).
   2) Inject dots + a "swipe" hint under horizontal card carousels so
      shoppers know there's more content to the right.               */
(function () {
  function init() {
    /* 1 — lazy autoplay videos */
    var vids = document.querySelectorAll("video[data-rvx-src]");
    function loadVid(v) {
      if (v.getAttribute("src")) return;
      v.src = v.getAttribute("data-rvx-src");
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (vids.length) {
      if ("IntersectionObserver" in window) {
        var vio = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              loadVid(e.target);
              vio.unobserve(e.target);
            });
          },
          { rootMargin: "400px 0px" }
        );
        vids.forEach(function (v) { vio.observe(v); });
      } else {
        vids.forEach(loadVid);
      }
    }

    /* 2 — swipe affordances for horizontal card scrollers */
    var scrollers = document.querySelectorAll(".rvx-pp3__grid, .rvx-cmp__grid");
    scrollers.forEach(function (sc) {
      if (sc.scrollWidth - sc.clientWidth < 40) return; /* not overflowing */
      var count = sc.children.length;
      var dots = document.createElement("div");
      dots.className = "rvx-scroll-dots";
      dots.setAttribute("aria-hidden", "true");
      for (var i = 0; i < count; i++) {
        var d = document.createElement("span");
        if (i === 0) d.className = "is-active";
        dots.appendChild(d);
      }
      var hint = document.createElement("div");
      hint.className = "rvx-swipe-hint";
      hint.setAttribute("aria-hidden", "true");
      hint.innerHTML = "Swipe <span>&rarr;</span>";
      sc.insertAdjacentElement("afterend", dots);
      dots.insertAdjacentElement("afterend", hint);
      var ticking = false;
      sc.addEventListener(
        "scroll",
        function () {
          hint.classList.add("is-done");
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var max = sc.scrollWidth - sc.clientWidth;
            if (max <= 0) return;
            var idx = Math.round((sc.scrollLeft / max) * (count - 1));
            var spans = dots.querySelectorAll("span");
            for (var j = 0; j < spans.length; j++) {
              spans[j].classList.toggle("is-active", j === idx);
            }
          });
        },
        { passive: true }
      );
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
